import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Input from 'src/components/Input/Input';
import { Button } from 'src/components/ui/button';
import { useNotification } from 'src/hooks/useNotification';
import { EMAIL } from 'src/shared/constants';
import type { SelectedIntegration } from 'src/store/slices/integrationSlice';

export const EditFreshchatSetupSettings = ({
  integration,
}: {
  integration?: SelectedIntegration;
}) => {
  const notification = useNotification();
  const { control } = useFormContext();
  const url = integration?.integration_data?.webhook_url;
  const email = EMAIL.SUPPORT;

  const copyUrl = async (e: React.MouseEvent) => {
    e.preventDefault();
    await navigator.clipboard.writeText(url);
    notification.success('Copied to clipboard');
  };

  const copyEmail = async (e: React.MouseEvent) => {
    e.preventDefault();
    await navigator.clipboard.writeText(email);
    notification.success('Copied to clipboard');
  };

  return (
    <div className={'w-full flex flex-col gap-2.5 py-2.5 px-5 bg-light rounded-sm-5'}>
      <ul className={'list-decimal p-2.5'}>
        <li className={'text-sm font-medium text-ebony_opacity_70'}>
          Open Freshchat Admin Settings → Marketplace & Integrations → Conversation Webhooks → Click
          “Enable”.
        </li>
        <li className={'text-sm font-medium text-ebony_opacity_70 mt-2'}>
          <p>Enter the below information in Freshсhat:</p>
          <div className={'flex flex-row items-end gap-1.5'}>
            <div>
              <Input
                type={'text'}
                label={'Webhook URL:'}
                placeholder={'Webhook URL'}
                value={url}
                isValid={true}
                className={
                  '!text-sm !py-2 !px-4 border-[#7A6BE5] hover:!border-[#7A6BE5] !text-[#7A6BE5] !bg-[#7A6BE50F]'
                }
                readonly={true}
              />
            </div>
            <Button className={'h-[38px] px-4'} onClick={copyUrl}>
              Copy
            </Button>
          </div>
          <div className={'flex flex-row items-end gap-1.5'}>
            <div>
              <Input
                type={'text'}
                label={'Email for failures:'}
                placeholder={'Email for failures'}
                value={email}
                isValid={true}
                className={
                  '!text-sm !py-2 !px-4 border-[#7A6BE5] hover:!border-[#7A6BE5] !text-[#7A6BE5] !bg-[#7A6BE50F]'
                }
                readonly={true}
              />
            </div>
            <Button className={'h-[38px] px-4'} onClick={copyEmail}>
              Copy
            </Button>
          </div>
        </li>
        <li className={'text-sm font-medium text-ebony_opacity_70 mt-2'}>
          Click "Save" in Freshchat — this will generate your Webhook API Key.
        </li>
        <li className={'text-sm font-medium text-ebony_opacity_70 mt-2'}>
          Click “Copy” under Authentication and paste your Webhook API Key below:
          <div>
            <Controller
              control={control}
              name="webhook_api_token"
              render={({ field: { onChange, value }, fieldState: { error } }) => (
                <Input
                  type={'text'}
                  placeholder={'Webhook API Key'}
                  invalidMessage={error?.message}
                  value={value}
                  isValid={!error?.message}
                  onChange={onChange}
                  className={'!text-sm !py-2 !px-4 mt-2'}
                  autoFocus={true}
                />
              )}
            />
          </div>
        </li>
      </ul>
    </div>
  );
};
